import isString = require("lodash/isString");
import isNumber = require("lodash/isNumber");
import isBoolean = require("lodash/isBoolean");
import {ID} from "../../metamodel/metaConstant";

export const TENANT_GROUP_THRESHOLD = 1000000;

export function formatId(...args) {
  return args.join('_');
}

/**
 * Parse id into string array
 *     e.g. 'Party_fullName' => ['Party', 'fullName']
 * @param id
 * @returns {*|Array}
 */
export function parseId(id: string): string[] {
  return id.split("_");
}


export function clone(object) {
  return (object) ? Object.assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}

export function addTenantToQuery(query?: any) {
  query = query || {};
  query.t = window.TENANT_ID;
  return query;
}

export function isTenantNumber(tenantId: ID) {
  return (tenantId != null && tenantId > 0 && tenantId < TENANT_GROUP_THRESHOLD);
}

export function getParam(name: string): string {
  let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function compare(v1, v2, locale) {
  if (v1 == null && v2 == null) {
    return 0;
  } else if (v1 == null) {
    return 1;
  } else if (v2 == null) {
    return -1;
  } else {
    if (isString(v1)) {
      return v1.localeCompare(v2, locale);
    } else if (isNumber(v1)) {
      return v1 - v2;
    } else if (isBoolean(v1)) {
      return (+v1) - (+v2);
    } else {
      throw new Error("type if v1 = " + (typeof v1) );
    }
  }
}


export function debounce(func, wait, immediate) {
  if (!wait) return func;

  let timeout;

  return function() {
    let context = this, args = arguments;

    let later = function() {
      timeout = null;

      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}


export const throttleWithRaf  = (fn) => {
  let running = false;

  return () => {
    if (running) return;

    running = true;

    window.requestAnimationFrame((...args) => {
      fn.apply(this, args);

      running = false;
    });
  };
};



// WEBPACK FOOTER //
// ./src/core/common/utils/utils.ts